<template>
  <b-container>
    <success-fade-alert ref="success" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <h4>
      {{ $t("forgotPassword.redefineByEmail") }}
    </h4>

    <b-form-group
      :label="$t('forgotPassword.cnpj')"
      label-for="input-companyDocument"
    >
      <b-form-input
        type="text"
        id="input-companyDocument"
        :placeholder="$t('forgotPassword.reportCnpj')"
        v-model="changePassowrd.companyDocument"
        v-mask="'99.999.999/9999-99'"
      />
      <span class="text-danger" v-if="modelstate['CompanyDocument']">
        {{ modelstate["CompanyDocument"][0] }}
      </span>
    </b-form-group>
    <b-form-group
      :label="$t('forgotPassword.accessName')"
      label-for="input-accessName"
    >
      <b-form-input
        type="text"
        id="input-accessName"
        :placeholder="$t('forgotPassword.reportAccessName')"
        label-for="input-accessName"
        v-model="changePassowrd.accessName"
      />
      <span class="text-danger" v-if="modelstate['AccessName']">
        {{ modelstate["AccessName"][0] }}
      </span>
    </b-form-group>
    <b-form-group :label="$t('forgotPassword.email')" label-for="input-email">
      <b-form-input
        type="text"
        id="input-email"
        :placeholder="$t('forgotPassword.reportEmail')"
        v-model="changePassowrd.email"
      />
      <span class="text-danger" v-if="modelstate['Email']">
        {{ modelstate["Email"][0] }}
      </span>
    </b-form-group>

    <b-button @click="send()">
      {{ $t("forgotPassword.sendEmail") }}
    </b-button>
  </b-container>
</template>
<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "ForgotPasswordComponent",
  directives: {
    mask: AwesomeMask,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Senha alterada com sucesso",
      },
      changePassowrd: {
        companyDocument: "",
        accessName: "",
        email: "",
      },
      modelstate: {},
    };
  },
  methods: {
    async send() {
      try {
        let companyDocument = this.changePassowrd.companyDocument;
        let accessName = this.changePassowrd.accessName;
        let email = this.changePassowrd.email;
        await this.$store
          .dispatch("forgotPassword", {
            companyDocument: companyDocument,
            accessName: accessName,
            email: email,
          })
          .then(() => {
            this.$refs.success.show();
            this.changePassowrd = {
              companyDocument: "",
              accessName: "",
              email: "",
            };
            this.modelstate = {};
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data);
            this.modelstate = error.response.data.errors;
            if (error.response) {
              this.alert.error = `${error.response.data.status} - ${error.response.data.title}`;
            } else {
              this.alert.error = error.toString();
            }
            this.$refs.danger.show();
          });
      } catch (error) {
        if (error.response) {
          if (error.response.status == 500) {
            this.alert.error = error.response.data;
            this.$refs.danger.show();
          } else {
            this.modelstate = error.response.data.errors;
            this.alert.error = `${error.response.status} - ${error.response.statusText}`;
            this.$refs.danger.show();
          }
        }
        console.log(error);
        this.alert.error = `Erro inexperado: ${error}`;
        this.$refs.danger.show();
      }
    },
  },
};
</script>
<style scoped>
h4 {
  color: #525f7f;
}

.right {
  text-align: right;
  width: 100%;
}
.forgetPassword {
  margin-top: -15px !important;
  margin-left: -20px;
  text-align: left !important;
}
</style>
